import EventEmitter from 'eventemitter3';
import TabButtonEvents from '../events/TabButtonEvents';
import { MovieClip, MouseEvent, getMovieClipByName } from '../utils/utils';

export default class TabButton {
  // ================================================================================================
  // properties
  // ================================================================================================
  private buttonClip: MovieClip;

  private button: MovieClip;

  private selectedImage: MovieClip;

  private buttonImage: MovieClip;

  private _events: EventEmitter;

  private _isSelected: boolean;

  // ================================================================================================
  // public
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  constructor(buttonClip: MovieClip) {
    this._events = new EventEmitter();

    this.buttonClip = buttonClip;

    this.button = getMovieClipByName(this.buttonClip, 'button');
    this.button.addEventListener('click', this.onClick.bind(this));

    this.buttonImage = getMovieClipByName(this.button, 'button');

    this.selectedImage = getMovieClipByName(this.buttonClip, 'selectedDisplay');
    this.selectedImage.visible = false;

    this.isSelected = false;
  }

  // ----------------------------------------------------------------------------------------------
  get events(): EventEmitter {
    return (this._events);
  }

  // ----------------------------------------------------------------------------------------------
  get isSelected(): boolean {
    return (this._isSelected);
  }

  // ----------------------------------------------------------------------------------------------
  set isSelected(value: boolean) {
    this._isSelected = value;
    this.selectedImage.visible = this._isSelected;
    this.buttonImage.visible = !this._isSelected;
    this.button.mouseEnabled = !this._isSelected;
  }

  // ================================================================================================
  // private
  // ================================================================================================

  // ----------------------------------------------------------------------------------------------
  private onClick(eventObj: unknown): void {
    this.events.emit(TabButtonEvents.PRESSED, <MouseEvent> eventObj, this);
  }
}
